import React from 'react';
import SIcon from './SIcon';
import { faVideo } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faVideo} fa />;

export default Icon;
